export default import.meta.ROLLDOWN_FILE_URL_6Qiidx85bktMy9U258qX3w